import { map, Observable } from 'rxjs';
import { filterRouteActive } from '../../router/declarative/filterRouteActive';
import { location$ } from '../../router/declarative/location$';
import { MetamodelActualNavigationState, MetamodelPane } from './types';

export const metamodelActualNavigation$: Observable<MetamodelActualNavigationState> =
  location$.pipe(
    filterRouteActive('/metamodel'),
    map(location => {
      switch (location.route) {
        case '/metamodel':
          return {
            pane: MetamodelPane.LIST,
            metamodelId: undefined,
          };
        case '/metamodel/edit':
          return {
            pane: MetamodelPane.LIST,
            metamodelId: undefined,
          };
        case '/metamodel/edit/:entityId':
          return {
            pane: MetamodelPane.EDIT,
            metamodelId: location.params.entityId,
          };
        case '/metamodel/:entityId':
          return {
            pane: MetamodelPane.SELECTED,
            metamodelId: location.params.entityId,
          };
        case '/metamodel/new':
          return {
            pane: MetamodelPane.EDIT,
            metamodelId: undefined,
          };
      }
    })
  );
